module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e8b9e772b56ad2e3fa52aa9d47919880.png";